module.exports = __webpack_public_path__ + "9488d02b/img/cadBim.e369a02a.png";